export const LINK_TYPE = {
  account: 'ACCOUNT',
  user: 'USER'
};
